<template>
    <div class="share-title">
        <p class="share-rule" @click="gotoPage(shareHeaderText.detailUrl)" v-if="showTips">
            {{ shareHeaderText.detail }}
        </p>
        <p class="share-big-title" v-html="shareHeaderText.title"></p>
        <p class="share-sub-title" v-html="shareHeaderText.desc"></p>
    </div>
</template>

<script>
export default {
    props: {
        shareHeaderText: Object,
        showTips: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        gotoPage(url) {
            window.location.href = url;
        },
    },
};
</script>

<style lang="scss" scoped>
.share-title {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 0.5rem;
    background: linear-gradient(180deg, #fff5e7 0%, #ffffff 100%);

    .share-big-title {
        color: #333;
        font-size: 0.34rem;
        text-align: center;
        font-weight: bold;
    }

    .share-sub-title {
        color: #ff3838;
        font-size: 0.26rem;
        margin-top: 0.1rem;
    }

    .share-rule {
        position: absolute;
        color: #999999;
        font-size: 0.24rem;
        top: 0.2rem;
        right: 0.4rem;
    }
}
</style>
